export default __webpack_public_path__ + "static/media/normal_u35.21874f87.png";